export default __webpack_public_path__ + "static/ghd-a5608131657dfc2e96d2c7de0974f14c.svg";